import { ScrollReveal } from "@components/motion/Transitioned"
import { cn } from "@utils/tw"
import { defineBlock, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Accordion",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/accordion", (props) => {
  return (
    <ScrollReveal>
      <div className={cn("w-cols-12 md:w-cols-8 mx-auto my-10")}>
        <div className="w-full md:max-w-contentWLarge mx-auto flex flex-col" data-transition="children/scale">
          <InnerBlocks
            allowedBlocks={["content/accordion-item"]}
            template={[
              ["content/accordion-item", {}],
              ["content/accordion-item", {}],
              ["content/accordion-item", {}],
            ]}
            adminClassName="w-full"
            orientation="vertical"
          />
        </div>
      </div>
    </ScrollReveal>
  )
})
